
module.exports = function getResource(label, vars = []) {
    const resources = {
        getItShippedTitle: `Faites livrer (${vars[0]})`,
        getItSooner: 'Obtenez-le plus rapidement',
        fulfillmentMsg: 'Cet article n’est pas disponible pour d’autres options d’exécution.',
        freeGift: 'Cadeau gratuit',
        item: `ITEM ${vars[0]}`,
        freeSample: 'Free Sample'
    };

    return resources[label];
};
